module.exports = __webpack_public_path__ + "img/10_94.64ea03d8.png";